import { render, staticRenderFns } from "./ArticleViewLogList.vue?vue&type=template&id=ad554528&scoped=true"
import script from "./ArticleViewLogList.vue?vue&type=script&lang=js"
export * from "./ArticleViewLogList.vue?vue&type=script&lang=js"
import style0 from "./ArticleViewLogList.vue?vue&type=style&index=0&id=ad554528&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad554528",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad554528')) {
      api.createRecord('ad554528', component.options)
    } else {
      api.reload('ad554528', component.options)
    }
    module.hot.accept("./ArticleViewLogList.vue?vue&type=template&id=ad554528&scoped=true", function () {
      api.rerender('ad554528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/articleViewLog/ArticleViewLogList.vue"
export default component.exports